import { create } from 'zustand';
import { Template } from '../generated/gql-types';
import { templateActions } from './template.action';
import { persist, createJSONStorage } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { pluralize } from '../util/utils';

export enum TemplateTerm {
  WORKER = '_WORKER_TERM_',
  CLIENT = '_CLIENT_TERM_',
  JOB = '_JOB_TERM_',
  TENANT = '_TENANT_TERM_',
  CANCEL = '_CANCEL_TERM_',
}

interface TemplateState {
  template: Template | null;
  setTemplate: (template: Template) => void;
  getTerm: (term: TemplateTerm, plural: boolean) => string;
  fetchAndSetTemplate: (tenantId: string) => Promise<Template | null>;
}

export const useTemplateStore = create<TemplateState>()(
  persist(
    (set, get) => ({
      //   state
      template: null,
      getTerm: (term: TemplateTerm, plural: boolean) => {
        return pluralize(get().template?.[term] || '', plural ? 2 : 1);
      },

      //   actions
      setTemplate: (template) => set({ template }),
      fetchAndSetTemplate: async (tenantId: string) => {
        const template = await templateActions.fetchTemplate(tenantId);
        set({ template });
        return template;
      },
    }),
    {
      name: 'template-storage',
      storage: createJSONStorage(() => AsyncStorage),
      partialize: (state) => ({ template: state.template }),
    },
  ),
);
